import React from 'react';
import { makeStyles} from '@material-ui/core/styles';
// import cx from 'clsx';
// import Avatar from '@material-ui/core/Avatar';
// import Box from '@material-ui/core/Box';
// import Card from '@material-ui/core/Card';
// import CardContent from '@material-ui/core/CardContent';
// import IconButton from '@material-ui/core/IconButton';
// import FavoriteBorderRounded from '@material-ui/icons/FavoriteBorderRounded';
// import Share from '@material-ui/icons/Share';
import { useSoftRiseShadowStyles } from '@mui-treasury/styles/shadow/softRise';
import { useN01TextInfoContentStyles } from '@mui-treasury/styles/textInfoContent/n01';
// import TextInfoContent from '@mui-treasury/components/content/textInfo';
// import image from '../../public/faces/5.jpg';
// import {AuthData} from '../Services/Authdata';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import useWindowDimensions from '../component/Dimension';

const useStyles1 = makeStyles(() => ({
    root: {
      maxWidth: 304,
      margin: 'auto',
    },
    content: {
      padding: 24,
    },
    avatar: {
        position:'absolute',
        marginTop:'-3%',
        marginLeft:'12%',
      width: 50,
      height: 50,
      border: '2px solid #fff',
      margin: '-48px 32px 0 auto',
      '& > img': {
        margin: 0,
      },
    },
  }));

export default function Profile(props) {
  const cardStyles = useStyles1();
  const shadowStyles = useSoftRiseShadowStyles();
  const textCardContentStyles = useN01TextInfoContentStyles();
  const { height, width } = useWindowDimensions();
  var totalFare = props.data.ItineraryInfo.ItineraryPricing.TotalFare.Amount;
  totalFare = parseFloat(totalFare) + (parseFloat(totalFare) * parseFloat(props.commission))/100;
  return (
        <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Passanger Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Gender</TableCell>
                    <TableCell align="right">Email</TableCell>
                    <TableCell align="right">DOB</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.data.ItineraryInfo.CustomerInfos.map((item,index)=>{
                            
                            return <TableRow  key={index}>
                                        <TableCell component="th" scope="row">
                                            {item.CustomerInfo.PassengerFirstName}
                                        </TableCell>
                                        <TableCell>{item.CustomerInfo.PassengerType}</TableCell>
                                        <TableCell>{item.CustomerInfo.Gender}</TableCell>
                                        <TableCell align="right">{item.CustomerInfo.EmailAddress}</TableCell>
                                        <TableCell align="right">{item.CustomerInfo.DateOfBirth}</TableCell>
                                    </TableRow>

                        })
                    }
                    
                </TableBody>
              </Table>
            </Box>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Flight Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>PNR</TableCell>
                    <TableCell>Departure Airport Code</TableCell>
                    <TableCell>Arrival Airport Code</TableCell>
                    <TableCell>Departuen Date & Time</TableCell>
                    <TableCell>Arrival Date & Time</TableCell>
                    <TableCell>Flight</TableCell>
                    <TableCell>Duration</TableCell>
                    <TableCell>Baggage</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.data.ItineraryInfo.ReservationItems.map((item,index)=>{
                            
                            return <TableRow key={index}>
                                        <TableCell component="th" scope="row">{item.ReservationItem.AirlinePNR}</TableCell>
                                        <TableCell component="th" scope="row">{item.ReservationItem.DepartureAirportLocationCode}</TableCell>
                                        <TableCell component="th" scope="row">{item.ReservationItem.DepartureDateTime}</TableCell>
                                        <TableCell component="th" scope="row">{item.ReservationItem.ArrivalAirportLocationCode}</TableCell>
                                        <TableCell component="th" scope="row">{item.ReservationItem.ArrivalDateTime}</TableCell>
                                        <TableCell component="th" scope="row">{item.ReservationItem.FlightNumber}</TableCell>
                                        <TableCell component="th" scope="row">{item.ReservationItem.JourneyDuration}</TableCell>
                                        <TableCell component="th" scope="row">{item.ReservationItem.Baggage}</TableCell>
                                    </TableRow>

                        })
                    }
                    <TableRow>
                            <TableCell rowSpan={4} />
                            <TableCell rowSpan={4} />
                            <TableCell rowSpan={4} />
                            <TableCell rowSpan={4} />
                            <TableCell rowSpan={4} />
                            <TableCell colSpan={2}>EquiFare</TableCell>
                            <TableCell align="right">{props.data.ItineraryInfo.ItineraryPricing.EquiFare.Amount+" "+props.data.ItineraryInfo.ItineraryPricing.TotalFare.CurrencyCode}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Service Tax</TableCell>
                            <TableCell align="right">{props.data.ItineraryInfo.ItineraryPricing.ServiceTax.Amount+" "+props.data.ItineraryInfo.ItineraryPricing.TotalFare.CurrencyCode}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Tax</TableCell>
                            <TableCell align="right">{props.data.ItineraryInfo.ItineraryPricing.Tax.Amount+" "+props.data.ItineraryInfo.ItineraryPricing.TotalFare.CurrencyCode}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell colSpan={2}>Total Fare</TableCell>
                            <TableCell align="right">{totalFare.toFixed(2)+" "+props.data.ItineraryInfo.ItineraryPricing.TotalFare.CurrencyCode}</TableCell>
                        </TableRow>
                    
                    
                </TableBody>
              </Table>
            </Box>
        </TableCell>
      </TableRow>
  );
}


// WEBPACK FOOTER //
// ./src/Pages/FlightDetail.js